import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { OpportunityEstimateView } from '@api-proxies';
import { EstimateTypes } from '@models/enums/EstimateTypes';
import { CustomPercentagePipe } from '@pipes/custom-percentage.pipe';
import { SectionSubHeaderComponent } from 'ngx-lib';

@Component({
    selector: 'app-estimates-sub-header',
    templateUrl: './estimates-sub-header.component.html',
    styleUrls: ['./estimates-sub-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, SectionSubHeaderComponent, CustomPercentagePipe]
})
export class EstimatesSubHeaderComponent implements OnChanges {
    @Input()
    opportunityEstimates?: OpportunityEstimateView[];

    baseEstimate?: OpportunityEstimateView;

    finalSelectedEstimate?: OpportunityEstimateView;

    grandTotal?: number;

    @Output()
    clicked: EventEmitter<boolean>;

    constructor() {
        this.clicked = new EventEmitter<boolean>();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.opportunityEstimates && changes['opportunityEstimates']) {
            this.setEstimates(this.opportunityEstimates);
        }
    }

    setEstimates(opportunityEstimate: OpportunityEstimateView[]): void {
        if (
            opportunityEstimate.length > 1 &&
            opportunityEstimate[1].estimateTypeId === EstimateTypes.Final &&
            opportunityEstimate[1].isSelected
        ) {
            this.finalSelectedEstimate = opportunityEstimate[1];
            this.grandTotal = this.calculateGrandTotal(this.finalSelectedEstimate);
        }
        this.baseEstimate = opportunityEstimate[0];
    }

    calculateGrandTotal(finalSelectedEstimate: OpportunityEstimateView): number {
        return (
            (finalSelectedEstimate.baseEstimateSellPrice ?? 0) +
            (finalSelectedEstimate.alternateTotalSellPrice ?? 0) +
            (finalSelectedEstimate.changeOrderTotalSellPrice ?? 0)
        );
    }

    navigate() {
        if (!this.opportunityEstimates) return;
        if (this.finalSelectedEstimate) {
            this.clicked.emit(true);
        } else {
            window.open(this.baseEstimate?.externalUrl, '_blank');
        }
    }
}
